// js
import engagementCompositeForm from './engagementCompositeForm';
import EngagementCustomerItem from './EngagementCustomerItem';


export default engagementCompositeForm({
  title: 'Customer Stakeholders',
  className: 'analytics__engagement-customers-form',
  displayName: 'EngagementCustomersForm',
  itemName: 'Customer Stakeholder',
  itemComponent: EngagementCustomerItem
});



// WEBPACK FOOTER //
// ./src/components/analytics/EngagementCustomersForm.js